import { useEffect } from "react";

import { ClientCartDetail } from "common/types/carts";
import LinkButton from "common/components/LinkButton";

import Breadcrumbs from "client/common/components/content/Breadcrumbs";
import { sendBeginCheckout } from "client/analytics/utils";

import { CheckoutStep } from "../types";

import styles from "../styles/CheckoutNavigation.module.less";

type CheckoutNavigationProps = {
  cart: ClientCartDetail;
  steps: CheckoutStep[];
  step: CheckoutStep;
  onNavigate: (step: CheckoutStep) => void;
};

const stepToLabel: { [K in CheckoutStep]: string } = {
  items: "Items",
  delivery: "Delivery",
  payment: "Payment",
};

const CheckoutNavigation = (props: CheckoutNavigationProps) => {
  const { cart, steps, step: activeStep, onNavigate } = props;

  useEffect(() => {
    sendBeginCheckout(cart);
    // We only want to send this when the user first enters checkout
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const activeIndex = steps.indexOf(activeStep);

  const items = steps.map((step, index) => {
    const label = stepToLabel[step];

    // Don't allow jumping ahead, only going back
    return index >= activeIndex ? (
      <span key={step} className={index === activeIndex ? styles.active : ""}>
        {label}
      </span>
    ) : (
      <LinkButton key={step} onClick={() => onNavigate(step)}>
        {label}
      </LinkButton>
    );
  });

  return <Breadcrumbs items={items} />;
};

export default CheckoutNavigation;
